module.exports = __webpack_public_path__ + "static/img/hover-3.f831760a.png";